import { ApiMethodDeclaration } from '..';

type ParamsData = {
    adminEmail: string;
    date: string;
};

type ResponseData = Array<{
    hour: number;
    requestCount: number;
    questroomsCreated: number;
    firstRequestAt: Date | null;
    lastRequestAt: Date | null;
}>;

export const getAllAdminsActivityByDate: ApiMethodDeclaration<ParamsData, ResponseData> = (
    params,
) => ({
    url: `/admins/activity/all/${encodeURIComponent(params.adminEmail)}/date/${params.date}`,
    method: 'GET',
    params: undefined,
});
